module.exports = __webpack_public_path__ + "img/avatar0.ea63228f.png";